import React from 'react';
import ChatMessage from './ChatMessage';

const ChatMessages = ({ 
  messages, 
  isSidebarVisible, 
  hasStartedChat, 
  botMessageHeight, 
  messagesEndRef, 
  botMessageRef, 
  handleModelDiagnostics, 
  handleInterpretResults, 
  isSending, 
  downloadPlot 
}) => {
  return (
    <div 
      className={`chat-messages${isSidebarVisible ? " sidebar-expanded" : ""} ${hasStartedChat ? 'active' : 'initial'}`}
      style={{ 
        paddingBottom: (() => {
          const lastMessage = messages[messages.length - 1];
          if (!lastMessage) return '20px';
          
          if (lastMessage.sender === 'user') {
            return '70vh';
          } else {
            const userPadding = window.innerHeight * 0.75;
            const adjustedPadding = Math.max(20, userPadding - botMessageHeight);
            return `${adjustedPadding}px`;
          }
        })()
      }}
    >
      {messages.map((message, index) => {
        const isLastBotMessage = index === messages.length - 1 && message.sender === 'bot';
        
        return (
          <ChatMessage 
            key={index}
            message={message}
            index={index}
            isLastBotMessage={isLastBotMessage}
            botMessageRef={botMessageRef}
            handleModelDiagnostics={handleModelDiagnostics}
            handleInterpretResults={handleInterpretResults}
            isSending={isSending}
            downloadPlot={downloadPlot}
          />
        );
      })}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default ChatMessages;
